import {Pipe, PipeTransform} from '@angular/core';
import {I18nServices} from "../i18n/i18n.service";

@Pipe({
    name: 'formatnumber',
    standalone: false
})
export class FormatNumberPipe implements PipeTransform {

  constructor(protected i18nService: I18nServices) {

  }

  public transform(value: number, minDecimals: number = 0, maxDecimals: number = null, useCompactNotation: boolean = true): string|null {

    if(value != null) {
      return this.i18nService.formatNumber(value, minDecimals, maxDecimals, useCompactNotation);
    }
    else {
      return "-";
    }

  }

}

